import { fiscalNumber } from "./fiscalNumber";
import {
  prevCityValidation,
  prevCountryValidation,
  prevHousenumberValidation,
  prevPostCodeValidation,
  prevStreetValidation,
} from "./prevLivingFields";
import { residentSince } from "./residentSince";
import {
  monthlyAlimonyFieldValidation,
  monthlyFeeInsuranceValidation,
  monthlyRateLeaseValidation,
  monthlyRatePropertyValidation,
  selfUsedPropertyValidation,
} from "./expenditureValidations";
import { birthDate } from "./birthDate";
import { street } from "./street";
import {
  professionGroupValidation,
  employmentLimitValidation,
  validateBusiness,
  validateEmployedSince,
  validateEmployerLocation,
  validateEmployment,
  validateEmploymerName,
  validateIndustryOfOccupation,
  validateProfession,
} from "./employmentValidations";
import { iban } from "./iban";
import { phoneNumberValidation } from "./phoneNumber";
import { houseNumber } from "./houseNumber";
import { validateEmail } from "./email";
import { name } from "./name";
import { merge, Rules } from "../technical";
import { money } from "./money";
import { validateCredits } from "./credits";
import { postalCode } from "./postalCode";
import {
  nonEuMandatory,
  residencePermitEndDateMandatory,
  workPermitEndDateMandatory,
} from "./nonEuPermit";
import { majorityShareholderCompaniesCityValidation, majorityShareholderCompaniesNameValidation } from "./majorityShareholderValidation";
import { liablePartnerCompanyCityValidation, liablePartnerCompanyNameValidation } from "./liablePartnerCompanyValidation";
import { monthlyCreditRateValidation } from "./monthlyCreditRateValidation";

const FunctionalRules = {
  salutation: Rules.required,
  title: Rules.none,
  firstName: merge(
    Rules.required,
    Rules.minLength(2),
    Rules.maxLength(35),
    name
  ),
  lastName: merge(
    Rules.required,
    Rules.minLength(2),
    Rules.maxLength(35),
    name
  ),
  maidenName: merge(Rules.minLength(2), Rules.maxLength(35), name),
  birthDate: merge(Rules.required, birthDate),
  placeOfBirth: merge(
    Rules.required,
    Rules.minLength(2),
    Rules.maxLength(30),
    name
  ),
  nationality: Rules.required,
  maritalStatus: Rules.required,
  livingStatus: Rules.required,
  fiscalNumber,
  iban: merge(Rules.required, iban),
  bic: Rules.required,
  street: merge(Rules.required, Rules.maxLength(30), street),
  housenumber: merge(
    houseNumber,
    Rules.minLength(1),
    Rules.maxLength(10),
    Rules.required
  ),
  postcode: merge(
    Rules.required,
    Rules.minLength(3),
    Rules.maxLength(10),
    postalCode
  ),
  city: merge(Rules.required, Rules.minLength(2), Rules.maxLength(30), name),
  country: Rules.required,
  countryCode: Rules.required,
  residentSince: merge(Rules.required, residentSince),
  prevstreet: prevStreetValidation,
  prevhousenumber: prevHousenumberValidation,
  prevpostcode: prevPostCodeValidation,
  prevcity: prevCityValidation,
  prevcountry: prevCountryValidation,
  email: merge(Rules.required, validateEmail),
  mobilePhoneCountryCode: Rules.required,
  mobilePhoneNumber: merge(Rules.required, phoneNumberValidation),
  allowUnsafeMailCommunication: Rules.required,
  professionGroup: merge(Rules.required, professionGroupValidation),
  employment: validateEmployment,
  business: validateBusiness,
  employerName: validateEmploymerName,
  employerLocation: validateEmployerLocation,
  employedSince: validateEmployedSince,
  employmentLimit: employmentLimitValidation,
  netIncome: merge(Rules.required, money),
  additionalNetIncome: money,
  livingConditions: Rules.required,
  selfUsedProperty: selfUsedPropertyValidation,
  monthlyRateLease: monthlyRateLeaseValidation,
  monthlyRateProperty: monthlyRatePropertyValidation,
  extraCost: merge(Rules.required, money),
  alimentChildrenCount: merge(Rules.required, Rules.integer),
  monthlyAlignmentFees: monthlyAlimonyFieldValidation,
  monthlyFeeInsurance: monthlyFeeInsuranceValidation,
  activeCreditContracts: Rules.required,
  insuranceType: Rules.required,
  otherObligationAlignment: Rules.required,
  credits: validateCredits,
  monthlyExpenses: merge(Rules.required, money),
  industryOfOccupation: validateIndustryOfOccupation,
  isLivingInDeStartDate: nonEuMandatory,
  residencePermitStatus: nonEuMandatory,
  workPermitStatus: nonEuMandatory,
  residencePermitEndDate: residencePermitEndDateMandatory,
  workPermitEndDate: workPermitEndDateMandatory,
  profession: validateProfession,
  monthlyCreditRate: monthlyCreditRateValidation,
  isMajorityShareholder: Rules.required,
  majorityShareholderCompanyName: majorityShareholderCompaniesNameValidation,
  majorityShareholderCompanyCity: majorityShareholderCompaniesCityValidation,
  isLiablePartner: Rules.required,
  liablePartnerCompanyName: liablePartnerCompanyNameValidation,
  liablePartnerCompanyCity: liablePartnerCompanyCityValidation,
  creditsAndLoans: Rules.required,
};

export { FunctionalRules };
